import React from 'react';
import { useSelector } from "react-redux";

function Banner() {
    const user = useSelector((state) => state.UserReducer.user);
    return (
        <div className="mx-auto p-4">
            <div className="bg-kuality-blue text-white rounded-lg p-8 md:p-16 flex items-center justify-between">
                <div>
                    <h2 className="text-3xl md:text-5xl font-bold mb-2">
                    {user ? `Welcome Back, ${user.first_name}!` : "Big Summer Sale!"}</h2>
                    <p className="text-lg mb-4">{user 
                            ? "Pick up where you left off. Your favorites are 50% off!" 
                            : "Up to 50% off on selected items. Don't miss out!"}</p>
                            <button className="bg-white text-kuality-blue font-semibold px-6 py-2 rounded-full hover:bg-kuality-bg transition">Shop Now</button>
                </div>
                <div className="hidden md:block">
                     <img src="https://placehold.co/300x200/FFFFFF/3B82F6?text=Sale!" alt="Sale Banner" className="rounded-lg"/>
                </div>
            </div>
        </div>
    );
}

export default Banner;
